import { makeAutoObservable } from 'mobx'
import { Database } from 'mobx-document'
import authenticationStore from './authenticationStore'
import { BeWizrMiscItemDocument } from './bewizr-misc-items'
import { register } from './support'

export class BeWizrMiscItemsStore {

  constructor() {
    makeAutoObservable(this)
  }

  public init() {
    authenticationStore.on('logout', this.onLogOut)
  }

  public readonly items = new Database<BeWizrMiscItemDocument>({
    getID:         item => item.id,
    getDocument:   item => new BeWizrMiscItemDocument(item.id, {initialData: item}),
    emptyDocument: id   => new BeWizrMiscItemDocument(id),
  })

  private onLogOut = () => {
    this.items.clear()
  }
}

export default register (new BeWizrMiscItemsStore())